module.exports = __webpack_public_path__ + "static/img/shoonya_features.2d4c7e9.webp";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/shoonya_features.webp
// module id = LOvP
// module chunks = 8